import type { ComponentPropsWithoutRef, ElementType } from "react";
import type { PillTitleOwnProps, PillTitleVariant } from "../../type/pill";

type PillTitleProps<T extends ElementType> = PillTitleOwnProps<T> &
  Omit<ComponentPropsWithoutRef<T>, keyof PillTitleOwnProps<T>>;

function getVariantClassName(variant: PillTitleVariant) {
  return variant === "blue-darkner"
    ? "pill-title-blue-darkner"
    : "pill-title-blue-brighter";
}

function getDefaultIconClassName(text?: string) {
  switch (text) {
    case "Historia badań":
    case "Results history":
      return "bi bi-clock-history";
    case "Audiometria tonalna":
    case "Pure-tone audiometry":
    case "Audiometria słowna":
    case "Verbal audiometry":
      return "bi bi-bar-chart-line";
    case "Mój profil":
    case "My profile":
      return "bi bi-person-circle";
    case "Badanie słuchu":
    case "Hearing test":
      return "bi bi-earbuds";
    case "Parametry":
    case "Parameters":
      return "bi bi-sliders";
    case "Parametry testu":
    case "Test parameters":
      return "bi bi-sliders2";
    case "Test tonu":
    case "Tone test":
      return "bi bi-soundwave";
    case "Wybór ucha":
    case "Ear selection":
      return "bi bi-ear";
    case "Kalibracja":
    case "Calibration":
      return "bi bi-sliders";
    default:
      return undefined;
  }
}

export default function PillTitle<T extends ElementType = "span">({
  as,
  variant,
  className,
  iconClassName,
  text,
  children,
  ...props
}: PillTitleProps<T>) {
  const Component = as ?? "span";
  const pillClassName = [getVariantClassName(variant), className].filter(Boolean).join(" ");
  const hasCustomContent = children !== undefined;
  const resolvedIconClassName = iconClassName ?? getDefaultIconClassName(text);

  return (
    <Component className={pillClassName} {...props}>
      {hasCustomContent ? (
        children
      ) : (
        <>
          {resolvedIconClassName && <i className={resolvedIconClassName}></i>}
          {text}
        </>
      )}
    </Component>
  );
}